export const VEHICLE_REGEX =
  /^((?:[가-힣]{2}[0-9]{1,2}|[0-9]{2,3})[가-힣]{1}[0-9]{4})$/;
export const PASSWORD_REGEX =
  /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/;
export const ID_REGEX = /^(?=.*[a-z])[a-z0-9]{5,16}$/;
export const PHONE_REGEX =
  /^((01[016789]{1}|02|0[3-9]{1}[0-9]{1})[0-9]{3,4}|1[568][0-9]{2})[0-9]{4}$/;
